import type { App } from "vue"
import { createI18n } from "vue-i18n"
import arSA from "./ar_SA"
import enUS from "./en_US"
import zhCN from "./zh_CN"
import trTR from "./tr_TR"
import koKR from "./ko_KR"
import { useAppStoreWithOut } from "@/store/modules/app"
import type { Language } from "@/store/modules/app/helper"

const appStore = useAppStoreWithOut()

const defaultLocale = appStore.lang || "en_US"

const i18n = createI18n({
    locale: defaultLocale,
    allowComposition: true,
    messages: {
        "ar_SA": arSA,
        "en_US": enUS,
        "zh_CN": zhCN,
        "tr_TR": trTR,
        "ko_KR": koKR
    },
})

export const t = i18n.global.t

export function setLocale(locale: Language) {
    i18n.global.locale = locale
}

export function setupI18n(app: App<Element>) {
    app.use(i18n)
}

export default i18n